import { LoadingState, SectionHeader } from '../../../shared/components/index.js';
import { useLeadsData } from '../hooks/useLeadsData.jsx';
import HtmlBlock from '../components/HtmlBlock.jsx';
import { buildAgingHtml, buildCohortHtml } from '../utils/present-leads-html.js';

/** Tendencias: antigüedad + cohorte (misma data GAS, sin inventar series). */
export default function LeadsTendenciasPage() {
  const { loading, data } = useLeadsData();
  if (loading && !data) return <LoadingState />;
  return (
    <div className="analytics-grid-2">
      <section className="analytics-section">
        <SectionHeader title="Antigüedad" note="Distribución de leads abiertos por edad." />
        <HtmlBlock
          html={buildAgingHtml((data && data.agingSinceCreation) || [], data && data.dataQuality)}
          className="analytics-panel"
        />
      </section>
      <section className="analytics-section">
        <SectionHeader title="Cohorte del período" note="Ingresos en el rango de fechas seleccionado." />
        <HtmlBlock html={buildCohortHtml(data && data.cohort)} className="analytics-panel" />
      </section>
    </div>
  );
}
